import { render, staticRenderFns } from "./CommunicationTypePage.vue?vue&type=template&id=07018586&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07018586')) {
      api.createRecord('07018586', component.options)
    } else {
      api.reload('07018586', component.options)
    }
    module.hot.accept("./CommunicationTypePage.vue?vue&type=template&id=07018586&", function () {
      api.rerender('07018586', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/configuration/communicationTypes/CommunicationTypePage.vue"
export default component.exports